import React from "react";
import { FormattedMessage } from "react-intl";
import { RoleEnum } from "../types/RoleEnum";
export var navigation = {
    onixCodetables: {
        path: "/bragency/onix-codetables",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.onix-codetables" }),
        roles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR],
    },
    onixCodetableItems: {
        path: "/bragency/onix-codetable-items",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.onix-codetables-items" })),
        roles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR],
    },
    internationalPrefixes: {
        path: "/bragency/international-prefixes",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.international-prefixes" })),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    agencyPrefixes: {
        path: "/bragency/agency-prefixes",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.agency-prefixes" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    publisherPrefixRanges: {
        path: "/bragency/publisher-prefix-ranges",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.publisher-prefix-ranges" })),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    publisherPrefixes: {
        path: "/bragency/publisher-prefixes",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefixes.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
        ],
    },
    naturalPersons: {
        path: "/bragency/natural-persons",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.DISTRIBUTOR,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
        ],
    },
    legalPersons: {
        path: "/bragency/legal-persons",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.DISTRIBUTOR,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
        ],
    },
    publishers: {
        path: "/bragency/publishers",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.label" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    collections: {
        path: "/bragency/collections",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.collections" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.DISTRIBUTOR,
            RoleEnum.COLLECTIONS_ADMINISTRATOR,
        ],
    },
    titles: {
        path: "/bragency/titles",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.title.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.DISTRIBUTOR,
        ],
    },
    products: {
        path: "/bragency/products",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.product.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.DISTRIBUTOR,
        ],
    },
    productNumbers: {
        path: "/bragency/product-numbers",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.label" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
            RoleEnum.DISTRIBUTOR,
        ],
    },
    coEditionRequests: {
        path: "/bragency/co-edition-requests",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.nav.coEditionRequests" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    adminEnvironmentVariables: {
        path: "/bragency/admin/environment-variables",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.admin" }),
        roles: [RoleEnum.SUPERUSER],
    },
    adminSolr: {
        path: "/bragency/admin/solr",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.admin.solr" }),
        roles: [RoleEnum.SUPERUSER],
    },
    adminAuthorityUpdate: {
        path: "/bragency/admin/authority-update",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.admin.authority-update" })),
        roles: [RoleEnum.SUPERUSER],
    },
    adminIssnRegister: {
        path: "/bragency/admin/issn-register",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.admin.issn-register" })),
        roles: [RoleEnum.SUPERUSER],
    },
    adminAlephTitleSync: {
        path: "/bragency/admin/aleph-title-sync",
        label: (React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.admin.aleph-title-sync" })),
        roles: [RoleEnum.SUPERUSER],
    },
    outputs: {
        path: "/bragency/outputs",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.outputs" }),
        roles: [
            RoleEnum.AGENCY_WORKER,
            RoleEnum.PUBLISHER_GUARANTOR,
            RoleEnum.PUBLISHER_ADMIN,
        ],
    },
    import: {
        path: "/bragency/import",
        label: React.createElement(FormattedMessage, { id: "ui-br-agency.navigation.import" }),
        roles: [RoleEnum.SUPERUSER],
    },
    // #Navigation
};
